import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, onMounted, onUnmounted, nextTick, watch } from 'vue';
import NotificationToast from './NotificationToast.vue';
import { subscribeToToast, ToastType } from '@/shared/lib/toast';

type ToastState = {
    show: boolean;
    message: string;
    title: string;
    type: ToastType;
    duration: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalToastHost',
  setup(__props) {

const toast = reactive<ToastState>({
    show: false,
    message: '',
    title: '',
    type: 'info',
    duration: 4000,
});

const queue: ToastState[] = [];
let unsubscribe: (() => void) | null = null;

const showToast = async (payload: ToastState) => {
    if (!toast.show) {
        toast.message = payload.message;
        toast.type = payload.type;
        toast.duration = payload.duration;
        await nextTick();
        toast.show = true;
    } else {
        queue.push({ ...payload, show: false });
    }
};

const handleClose = () => {
    toast.show = false;
};

watch(
    () => toast.show,
    (isShown) => {
        if (!isShown && queue.length) {
            const next = queue.shift();
            if (next) {
                showToast(next);
            }
        }
    }
);

onMounted(() => {
    unsubscribe = subscribeToToast(({ message, title, type, duration }) => {
        showToast({
            message,
            title,
            type,
            duration,
            show: false,
        });
    });
});

onUnmounted(() => {
    if (unsubscribe) unsubscribe();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NotificationToast, {
    show: toast.show,
    message: toast.message,
    title: toast.title,
    type: toast.type,
    duration: toast.duration,
    onClose: handleClose
  }, null, 8, ["show", "message", "title", "type", "duration"]))
}
}

})